import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    Security as SecurityIcon,
    Home as HomeIcon,
    CheckCircle as CheckCircleIcon,
    Warning as WarningIcon,
    Group as GroupIcon,
    NotificationsActive as NotificationsActiveIcon,
    Phone as PhoneIcon,
    MeetingRoom as MeetingRoomIcon,
    Lock as LockIcon,
    Shield as ShieldIcon,
    MenuBook as MenuBookIcon,
    Close as CloseIcon,
    ListAlt as ListAltIcon,
    EventAvailable as EventAvailableIcon,
    PeopleOutline as PeopleOutlineIcon,
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>
                                目次
                            </Typography>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => setShowToc(false)}
                                sx={{ ml: 2, minWidth: 32, px: 1 }}
                                startIcon={<CloseIcon fontSize="small" />}
                            >
                                閉じる
                            </Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1,
                                    fontSize: '1.1rem'
                                }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem', px: 0 }}>
                                    ルームシェアの防犯面での魅力とは
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1,
                                    fontSize: '1.1rem'
                                }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('merit')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem', px: 0 }}>
                                    防犯面のメリット
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1,
                                    fontSize: '1.1rem'
                                }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('equipment')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem', px: 0 }}>
                                    ルームシェアのセキュリティ設備
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1,
                                    fontSize: '1.1rem'
                                }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('habit')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem', px: 0 }}>
                                    日常でできる防犯習慣
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1,
                                    fontSize: '1.1rem'
                                }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('cooperation')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem', px: 0 }}>
                                    共同で行う防災・防犯対策
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1,
                                    fontSize: '1.1rem'
                                }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem', px: 0 }}>
                                    トラブル時の連絡体制
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32,
                                    minHeight: 32,
                                    bgcolor: '#f5f5f5',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1,
                                    fontSize: '1.1rem'
                                }}>
                                    7.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem', px: 0 }}>
                                    まとめ
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                    startIcon={<MenuBookIcon fontSize="small" />}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアの防犯面での魅力とは
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" gutterBottom>
                    近年、ルームシェアの人気が高まりつつあります。家賃や生活費の節約だけでなく、<b>防犯面での安心感</b>を理由に選ぶ人も増えています。<br />
                    一人暮らしに比べて、<b>複数人で暮らすこと自体が大きな防犯効果</b>をもたらします。しかし、安心して暮らすためには、設備や日々の習慣、住人同士の協力体制が欠かせません。
                </Typography>
                <Box sx={{ my: 3 }}>

                </Box>
                <Typography variant="body1">
                    この記事では、<b>ルームシェアにおける防犯対策のポイント</b>と、より安心して暮らすための工夫を具体的に解説します。<br />
                    これからルームシェアを始めたい方も、すでに住んでいる方も、ぜひ参考にしてみてください。
                </Typography>
            </Box>

            {/* 防犯面のメリット */}
            <Box id="merit" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <SecurityIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
                    防犯面のメリット
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" gutterBottom>
                    ルームシェア最大のメリットは、<b>「家に誰かがいる」状態が多い</b>こと。空き巣や不審者は「人の気配」が苦手です。<br />
                    具体的な防犯上の強みを整理すると、以下のようになります。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <GroupIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={<b>常に誰かが在宅している安心感</b>}
                            secondary="早朝深夜の帰宅や外出でも、誰かが家にいることで犯罪抑止効果が高まります。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <NotificationsActiveIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={<b>トラブル時の迅速な対応</b>}
                            secondary="異変に気付きやすく、緊急時には助けを呼びやすい環境です。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <ShieldIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={<b>防犯意識の共有・相互チェック</b>}
                            secondary="住人同士で注意を促し合えるため、防犯意識が高まりやすいです。"
                        />
                    </ListItem>
                </List>
                <Box sx={{ mt: 3 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Paper elevation={2} sx={{ p: 2, borderRadius: 2, minHeight: 120 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    ルームシェアは「人の目」による防犯が最大の強み
                                </Typography>
                                <Typography variant="body2">
                                    一人暮らしの部屋と比べて、外部から「留守」と思われにくい点も大きなポイントです。<br />
                                    例えば郵便物が溜まっている…などの状況も、住人同士で気付きやすくなります。
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Paper elevation={2} sx={{ p: 2, borderRadius: 2, minHeight: 120 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    不審者への抑止力
                                </Typography>
                                <Typography variant="body2">
                                    実際に空き巣犯の多くは「複数人暮らしの家」を避ける傾向が統計で示されています。
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            {/* セキュリティ設備 */}
            <Box id="equipment" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <LockIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
                    ルームシェアのセキュリティ設備
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" gutterBottom>
                    特に、次のような設備があると安心感が高まります。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <HomeIcon color="action" />
                        </ListItemIcon>
                        <ListItemText
                            primary="オートロック・ダブルロック"
                            secondary="建物の入口や各部屋にオートロックや二重ロックが設置されているかチェックしましょう。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <SecurityIcon color="action" />
                        </ListItemIcon>
                        <ListItemText
                            primary="防犯カメラ"
                            secondary="エントランスや共有部に設置されていると、不審者への抑止力が格段に上がります。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <MeetingRoomIcon color="action" />
                        </ListItemIcon>
                        <ListItemText
                            primary="各個室の鍵"
                            secondary="プライバシー確保とともに、盗難やトラブル時の備えとしても有効です。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <WarningIcon color="action" />
                        </ListItemIcon>
                        <ListItemText
                            primary="非常ベル・インターホン"
                            secondary="緊急時にすぐ知らせられるシステムがあると、安心して暮らせます。"
                        />
                    </ListItem>
                </List>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/security-system_roomshare-security-tips.jpg"
                        alt="ルームシェア物件の玄関に設置されたオートロックシステムと防犯カメラ。近代的なデザインで、住人の安全を守るための設備が整っていることを示す"
                        style={{ width: "100%", borderRadius: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.12)" }}
                    />
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    物件を選ぶ際は、これらの設備が備わっているか確認することが大切です。<br />
                    住み始めた後も、定期的に設備の点検やメンテナンスを行いましょう。
                </Typography>
            </Box>

            {/* 日常の防犯習慣 */}
            <Box id="habit" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <CheckCircleIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
                    日常でできる防犯習慣
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" gutterBottom>
                    どんなに設備が整っていても、<b>日々のちょっとした油断</b>がトラブルにつながることも。<br />
                    ルームメイト全員ができる工夫とルール作りが、快適な共同生活のカギです。
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <Chip label="防犯習慣チェックリスト" color="primary" variant="outlined" sx={{ mb: 1 }} />
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="外出時は必ず施錠"
                                secondary="玄関・窓・バルコニーなど、共用部も含めて確認。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <PeopleOutlineIcon color="action" />
                            </ListItemIcon>
                            <ListItemText
                                primary="来客時のルール徹底"
                                secondary="誰かを招くときは事前にグループチャットで報告。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <EventAvailableIcon color="action" />
                            </ListItemIcon>
                            <ListItemText
                                primary="長期不在時は情報共有"
                                secondary="旅行や帰省の際は、ルームメイトに伝えておく。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <LockIcon color="action" />
                            </ListItemIcon>
                            <ListItemText
                                primary="個室や貴重品の施錠"
                                secondary="大事なものは自分で守る意識が大切です。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <ListAltIcon color="action" />
                            </ListItemIcon>
                            <ListItemText
                                primary="ゴミ・郵便物の管理"
                                secondary="郵便物やチラシの放置は「不在アピール」につながるので注意。"
                            />
                        </ListItem>
                    </List>
                </Box>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/checklist-roomshare_roomshare-security-tips.jpg"
                        alt="ルームシェアの住人たちがリビングで集まり、防犯・生活ルールのチェックリストを確認し合っている様子。明るく協力的な雰囲気"
                        style={{ width: "100%", borderRadius: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.12)" }}
                    />
                </Box>
                <Typography variant="body2" color="text.secondary">
                    住人同士で「見守り合う」文化を作ることが、防犯にも信頼関係づくりにもつながります。
                </Typography>
            </Box>

            {/* 共同で行う防災・防犯対策 */}
            <Box id="cooperation" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <GroupIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
                    共同で行う防災・防犯対策
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" gutterBottom>
                    ルームシェアの強みは、<b>みんなで備えられること</b>。<br />
                    防犯だけでなく、防災（地震・火災など）も日頃から一緒に考えておくと、いざという時に安心です。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <ShieldIcon color="action" />
                        </ListItemIcon>
                        <ListItemText
                            primary="防犯・防災マニュアルの共有"
                            secondary="玄関や共有スペースに掲示したり、グループチャットで定期的に確認。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <WarningIcon color="warning" />
                        </ListItemIcon>
                        <ListItemText
                            primary="避難経路や消火器の確認"
                            secondary="新しい住人が来た時は必ず説明を。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <EventAvailableIcon color="success" />
                        </ListItemIcon>
                        <ListItemText
                            primary="定期的な防犯・防災チェック"
                            secondary="みんなで年に1〜2回、点検や訓練をしておくと良いでしょう。"
                        />
                    </ListItem>
                </List>
                <Paper elevation={1} sx={{ p: 2, mt: 2, borderLeft: "6px solid #1976d2", background: "#f5f9fd" }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                        専門家からのアドバイス
                    </Typography>
                    <Typography variant="body2">
                        ルームシェアでは、「自分だけの部屋」ではなく「みんなの家」という意識が重要です。<br />
                        定期的な話し合いやルールの見直しを通じて、安全な住まいを作りましょう。
                    </Typography>
                </Paper>
            </Box>

            {/* トラブル時の連絡体制 */}
            <Box id="trouble" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <PhoneIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
                    トラブル時の連絡体制
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" gutterBottom>
                    共同生活で最も大切なのは、<b>いざという時にすぐ連絡が取れる体制</b>です。<br />
                    防犯トラブルだけでなく、体調不良や災害時にも活躍します。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <NotificationsActiveIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="グループチャットの活用"
                            secondary="LINEやSlackなど、全員がすぐに読めるツールを用意しましょう。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <PhoneIcon color="action" />
                        </ListItemIcon>
                        <ListItemText
                            primary="緊急時の連絡先リスト"
                            secondary="警察・消防・管理会社・大家さんなどもまとめておくと安心です。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <PeopleOutlineIcon color="action" />
                        </ListItemIcon>
                        <ListItemText
                            primary="住人全員の連絡先共有"
                            secondary="電話番号やLINE IDなど、最低限は共有しておきましょう。"
                        />
                    </ListItem>
                </List>
                <Box sx={{ my: 3 }}>

                </Box>
                <Typography variant="body2" color="text.secondary">
                    連絡体制が整っていることで、もしもの時も「独りじゃない」安心感につながります。
                </Typography>
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <ListAltIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
                    まとめ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" gutterBottom>
                    ルームシェアは、<b>複数人で暮らすこと自体が最大の防犯対策</b>。<br />
                    さらに、設備・日々の習慣・連絡体制を工夫することで、一人暮らしよりも格段に安心できる住まいを実現できます。
                </Typography>
                <Box sx={{ mt: 3 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1 }}>
                                    今日からできるポイント
                                </Typography>
                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <CheckCircleIcon color="success" />
                                        </ListItemIcon>
                                        <ListItemText primary="玄関・窓の施錠を徹底" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <CheckCircleIcon color="success" />
                                        </ListItemIcon>
                                        <ListItemText primary="ルールの共有・情報交換を習慣化" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <CheckCircleIcon color="success" />
                                        </ListItemIcon>
                                        <ListItemText primary="困ったときはすぐ連絡" />
                                    </ListItem>
                                </List>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1 }}>
                                    ルームシェアで得られる安心
                                </Typography>
                                <Typography variant="body2">
                                    人とのつながりが生む「安心感」は、どんな防犯グッズよりも大きな力になります。<br />
                                    みんなで協力し合い、快適で安全なルームシェア生活を楽しみましょう。
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-security-tips',
    slug: 'roomshare-security-tips',
    title: 'ルームシェアの防犯対策：一人暮らしより安心な暮らしのための工夫',
    excerpt: 'ルームシェアの防犯面のメリットや、セキュリティ設備・日常でできる防犯習慣・共同での防災対策・トラブル時の連絡体制まで、安心して暮らすための実践的な工夫を詳しく解説。',
    coverImage: '/images/blog/cover-roomshare-security_roomshare-security-tips.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。安心感と協力による安全な暮らしのイメージを表現',
    publishedAt: '2024-06-15T00:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '防犯・セキュリティ', '暮らしの知恵'],
    tags: ['防犯対策', 'ルームシェア', 'セキュリティ', '共同生活', 'トラブル対応'],
    author: {
        name: '山本 俊介',
        avatar: '/images/avatars/yamamoto.jpg',
        bio: 'シェアハウス・共同生活の現場を数多く取材。住まいと防犯の専門知識を活かし、安全で快適なルームシェアの実現をサポートしています。',
        profilePicture: '/images/avatars/yamamoto.jpg'
    },
    viewCount: 1432,
    contentComponent: PostContent
};

export default post;